<template>
  <b-container class="tracking pt-5">
    <b-row>
      <b-col lg="12" xl="3" class="tracking__control bg-light"
        :class="{
          'pl-3 pr-3 pt-3': selectedShipment,
          'p-3': !selectedShipment
        }">
        <b-row>
          <b-col md="12">
            <base-multiselect
              :loading="shipmentSelectorLoading"
              :internalSearch="false"
              :options="shipmentList"
              :searchable="true"
              :label="'number'"
              :track-by="'id'"
              :placeholder="'Search shipment number'"
              :initSelect="selectedShipmentId"
              @open="onDropdown"
              @search-change="findShipment"
              @input-value="onSelectShipment"
            ></base-multiselect>
          </b-col>
          <b-col md="12" v-if="selectedShipment" class="bg-dark mt-3 p-3">
            <p class="h6 text-secondary">
              Shipment
              <span class="pull-right pr-3">
                <p class="h6 text-secondary">
                  Completion
                </p>
                <p class="h5 mb-4">
                  <span class="text-light">{{ selectedShipment.total_percentage }} %</span>
                </p>
              </span>
            </p>
            <p class="h5 mb-4"><router-link :to="`/shipment_md/shipments/${selectedShipment.id}`" class="text-light">No. {{ selectedShipment.number }}</router-link></p>

            <p class="h6 text-secondary">
              Truck
              <span class="pull-right pr-3">
                <p class="h6 text-secondary">
                  Driver
                </p>
                <p class="h6 mb-4">
                  <span class="text-light">{{ selectedShipment.vehicle.driver.name }}</span>
                </p>
              </span>
            </p>
            <p class="h6 text-light mb-1">{{ selectedShipment.vehicle.reg_no }}</p>
            <p class="text-muted mb-3">{{ selectedShipment.vehicle.company.name }}</p>

            <p class="h6 text-secondary">Company</p>
            <p class="h6 mb-4">
              <span class="text-light">{{selectedShipment.company.name  }}</span>
            </p>

          </b-col>
        </b-row>
      </b-col>
      <b-col class="tracking__map" v-if="selectedShipment && loaded">
        <base-tracking
          :zoom="zoom"
          :marker="selectedShipment.destinations"
          :origin="selectedShipment.origin"
          :center="center"
        ></base-tracking>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import { debounce } from 'lodash';
  import BaseMultiselect from '@/components/BaseMultiselect';
  import BaseTracking from '@/components/BaseTracking';

  export default {
    name: 'shipment-tracking',
    components: {
      BaseMultiselect,
      BaseTracking,
    },
    data() {
      return {
        loaded: false,
        shipmentSelectorLoading: false,
        shipmentList: [],
        selectedShipment: null,
        selectedShipmentId: null,
        recursive: null,
        zoom: 3,
        center: [-0.789275, 113.92132700000002],
      };
    },
    created() {
      this.$store.commit('SET_BREADCRUMB_ITEMS', [
        { to: '', name: 'Home' },
        { to: 'shipment_md', name: 'Shipment MD' },
        { to: 'shipments', name: 'Shipments' },
        { to: 'tracking', name: 'Tracking' },
      ]);
      this.$store.commit('shipment_md/shipments/CLEAR_QUERY');
      this.$store.dispatch('shipment_md/shipments/LOAD_INFO').then(() => {
        const shipment_count = this.$store.getters['shipment_md/shipments/count_all'];
        this.$store.commit('shipment_md/shipments/SET_QUERY_COUNT', shipment_count);
      });
    },
    methods: {
      findShipment: debounce(function findShipment(query) {
        const payload = { value: query.trim() };
        this.shipmentSelectorLoading = true;

        return this.$store.dispatch('shipment_md/shipments/FREE_SEARCH_DATA', payload).then(({ data }) => {
          const { shipments } = data;

          if (query.trim() !== '') {
            this.shipmentList = shipments;
          } else {
            this.shipmentList = shipments.filter((s, index) => index <= 4);
          }

          this.shipmentSelectorLoading = false;
        });
      }, 5e2),
      onSelectShipment(shipment) {
        const { value } = shipment;
        const id = value === null ? null : value.id;
        this.selectedShipmentId = id;
        if (id !== null) {
          this.$store.commit('shipment_md/shipments/SET_DETAIL_ID', id);
          this.$store.dispatch('shipment_md/shipments/LOAD_DETAIL_DATA_SUMMARY').then((detail) => {
            detail.origin.marker = this.addressToLL(detail.origin.metadata.info.address);
            detail.destinations.map((dest) => {
              dest.marker = this.addressToLL(dest.address);
              return dest;
            });
            this.selectedShipment = detail;
            this.loaded = true;
          });
        } else {
          this.selectedShipment = null;
        }
      },
      onDropdown() {
        if (this.shipmentList.length > 0) return false;
        return this.$store.dispatch('shipment_md/shipments/FREE_SEARCH_DATA', { value: '' }).then(({ data }) => {
          const { shipments } = data;
          this.shipmentList = shipments.filter((s, index) => index <= 4);
        });
      },
      addressToLL(address) {
        const marker = { lat: 0, lng: 0 };
        this.$store.dispatch('shipment_md/locations/SEARCH_ADDRESS', address).then((data) => {
          if (data.length) {
            const { geometry: { location: { lat, lng } } } = data[0];
            marker.lat = lat;
            marker.lng = lng;
          }
        });
        return marker;
      },
      recursiveLoadShipment() {
        // TODO: Recursive Load Vehicle Position
      },
    },
  };
</script>

<style lang="sass">
  @import "~vue-multiselect/dist/vue-multiselect.min"

  .leaflet-control-container
    height: 550px !important

  .tracking__control
    height: 75px

  .tracking__map
    @media screen and (max-width: 1024px)
      padding: 250px 1px 10px 1px
</style>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/shipments/tracking/Index.vue